import styled from 'styled-components';
import { UserActionsMetadata } from 'modules/campaigns/lib/components';
import { Link } from 'ui/links';
import { useEditableFieldsContext } from '../context/EditableFieldsContext';

const LinkWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-start;
  justify-content: flex-end;
`;

export const SettingsCreatorAndModifierSection = () => {
  const { liveTemplate } = useEditableFieldsContext();
  const LINK_NAME = 'View revision history';

  return (
    <UserActionsMetadata
      creator={liveTemplate?.creatorUser || ''}
      modifier={liveTemplate?.updatedByUser || ''}
      createdDate={liveTemplate?.createdAt || ''}
      modifiedDate={liveTemplate?.updatedAt || ''}
    >
      <LinkWrapper data-test="version-history-detail-row">
        <Link
          hasOpenNewTabIcon
          href={`/templates/history?templateId=${liveTemplate?.templateId || ''}`}
          target="_blank"
        >
          {LINK_NAME}
        </Link>
      </LinkWrapper>
    </UserActionsMetadata>
  );
};
